import { render, staticRenderFns } from "./TopLocationBackgroundShape3.vue?vue&type=template&id=2907e20c&scoped=true&"
import script from "./TopLocationBackgroundShape3.vue?vue&type=script&lang=js&"
export * from "./TopLocationBackgroundShape3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907e20c",
  null
  
)

export default component.exports